import type { Reporter } from './types';

/**
 * Development / default reporter. Logs to the console and caches the
 * current user so `captureError` has something to correlate with during
 * local debugging. Intentionally verbose.
 */
export function createConsoleReporter(): Reporter {
  let user: { id: string; email?: string } | null = null;
  return {
    captureError(error, context) {
      console.error('[monitoring]', error, { user, ...context });
    },
    captureMessage(message, context) {
      console.warn('[monitoring]', message, { user, ...context });
    },
    captureMetric(name, value, context) {
      console.info(`[metric] ${name} = ${String(value)}`, { user, ...context });
    },
    setUser(next) {
      user = next;
    },
  };
}
